import { render } from "./CreateAccount.vue?vue&type=template&id=78ed2a08&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=78ed2a08&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ed2a08"]])

export default __exports__